var React = require('react');

function Crown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1.5V8.5H9V1.5L6.75 3.6L4.5 0L2.25 3.6L0 1.5Z","fill":"#F3CE0A"}));
}

Crown.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none"};

module.exports = Crown;

Crown.default = Crown;
